import { Table as MuiTable, withStyles } from '@material-ui/core';

const Table = withStyles({
  stickyHeader: {
    borderCollapse: 'collapse'
  }
})(MuiTable);

export default Table;
